import { createStore } from 'vuex'
import fnolModule from './modules/fnolModule'

const store = createStore({
  modules: {
    fnol: fnolModule
  }
})

export default store
